import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import App from 'src/App';
import IntegrationCredentials from 'src/integrations/credentials';
import PrivateRoute from 'src/routes/private';
import { useFeatureFlagsController } from 'src/hooks/use-feature-flags-controller';

import LoginRoute from 'src/routes/login';
import TransferRoute from 'src/routes/transfer';
import ForgotPasswordRoute from 'src/routes/forgot-password';
import SetPasswordRoute from 'src/routes/set-password';
import ResetPasswordRoute from 'src/routes/reset-password';
import DispensariesMenuPreview from 'src/dispensary-admin/preview';

import DeliveryPage from 'src/delivery';
import ExternalReceipt from 'src/external-receipt';

/**
 * Inner router component that has access to Router context.
 * useFeatureFlagsController needs to be inside BrowserRouter so useParams works for enterprise routes.
 */
function RouterContent() {
  useFeatureFlagsController();

  return (
    <QueryParamProvider ReactRouterRoute={Route}>
      <Switch>
        <Route path='/delivery/:id/:token' component={DeliveryPage} />
        <Route path='/receipt/:id/:token' component={ExternalReceipt} />
        <Route path='/integrations/:adapter' component={IntegrationCredentials} />
        <PrivateRoute path='/dispensaries/:id/preview' component={DispensariesMenuPreview} />

        <Route path='/login' component={LoginRoute} />
        <Route path='/transfer' component={TransferRoute} />
        <Route path='/forgot-password' component={ForgotPasswordRoute} />
        <Route path='/set-password/:token' component={SetPasswordRoute} />
        <Route path='/reset/:token' component={ResetPasswordRoute} />

        <PrivateRoute path='/*' component={App} />
      </Switch>
    </QueryParamProvider>
  );
}

export default function DutchieRouter() {
  return (
    <BrowserRouter>
      <RouterContent />
    </BrowserRouter>
  );
}
